import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

const ShimmerText = () => {
  const shimmerControls = useAnimation();

  useEffect(() => {
    let timeout;
    const animateShimmer = () => {
      shimmerControls.start({
        translateX: ["-60%", "100%"],
        opacity: [1, 1, 0],
        transition: { duration: 1.7, ease: "easeInOut" }
      });
      timeout = setTimeout(animateShimmer, 7000);
    };
    animateShimmer();
    return () => clearTimeout(timeout);
  }, [shimmerControls]);

  return (
    <motion.div
      initial={{ translateX: "-60%", opacity: 0 }}
      animate={shimmerControls}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 2,
        background:
          "linear-gradient(60deg, rgba(255,255,255,0) 30%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0) 70%)",
        borderRadius: "inherit",
        filter: "blur(0px)",
        mixBlendMode: "screen",
        willChange: "transform",
      }}
    />
  );
};

export default ShimmerText;
